/* PACKAGES */
import React from 'react';

import { getMediaChild } from '../../utils/slider';

const SliderOther = ({ childrenCopy, Other, openZoom, index }) => {
	const currentSlide = React.Children.toArray(childrenCopy).slice(index - 1, index);
	const src = (getMediaChild(currentSlide)?.[0]?.props?.src || '').replace(/_\d+x\.(.+)$/, '.$1');

	return <Other index={index} imageSrc={src} openZoom={openZoom} />;
};

export default SliderOther;
